import React from "react";
import { LexicalComposer } from "@lexical/react/LexicalComposer";

import Skeleton from "components/skeleton";
import { useLoader } from "hooks";


import LexicalContainer from "./lexicalContainer";
import Nodes from "./nodes";
import theme from "./themes/index";

type EditorProps = {
	namespace: string;
	isLoading: boolean;
	editable?: boolean;
	defaultValues?: string;
	maxLength: number;
	onChange: Function;
	onBlur?: Function;
};

const Editor = ({
	namespace,
	isLoading,
	editable = true,
	defaultValues = "",
	maxLength,
	onChange,
	onBlur,
}: EditorProps) => {
	const Loader = useLoader(isLoading);

	const initialConfig = {
		// Used for save Editor`s current state to localStorage
		namespace: namespace,
		editable: editable,
		editorState: null,
		// The editor theme
		theme: theme,
		// Handling of errors during update
		onError(error) {
			throw error;
		},
		// Any custom nodes go here
		nodes: [...Nodes],
	};

	return (
		<Loader
			skeleton={<Skeleton height={105} />}
			component={
				<LexicalComposer initialConfig={initialConfig}>
					<LexicalContainer
						namespace={namespace}
						editable={editable}
						defaultValues={defaultValues}
						maxLength={maxLength}
						onChange={onChange}
						onBlur={onBlur}
					/>
				</LexicalComposer>
			}
		/>
	);
};

export default Editor;
